import { render, staticRenderFns } from "./MobIndex.vue?vue&type=template&id=8e8bb86e&scoped=true&"
import script from "./MobIndex.vue?vue&type=script&lang=js&"
export * from "./MobIndex.vue?vue&type=script&lang=js&"
import style0 from "./MobIndex.vue?vue&type=style&index=0&id=8e8bb86e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8bb86e",
  null
  
)

export default component.exports